module.exports = __webpack_public_path__ + "img/ccs-logo.495a615c.png";